import {Component, EventEmitter, inject, Input, OnInit, Output, signal} from '@angular/core';
import {StepContainerAction} from './step-container-action.enum';
import {ToastService} from '../../core/services/toast/toast.service';
import {SubsidyType} from '../../models/subsidy-type.type';
import {SubsidyPeriod} from '../../models/subsidy-period.model';
import {SubsidiesStore} from '../../services/subidies/subsidies.store';
import {take} from "rxjs/operators";

@Component({
	selector: 'tvsub-step-container',
	templateUrl: './step-container.component.html',
	styleUrls: ['./step-container.component.scss'],
	standalone: false
})
export class StepContainerComponent implements OnInit {
	@Input()
	denyPrevious: boolean = false;
	@Input()
	isDossier: boolean = false;
	@Input()
	step: number;
	@Input()
	steps: string[];
	@Input()
	subsidyType: SubsidyType;
	@Output()
	action: EventEmitter<StepContainerAction> = new EventEmitter();

	isLastStep = signal(false);
	period = signal<SubsidyPeriod | null>(null);

	StepContainerAction = StepContainerAction;

	subsidiesStore = inject(SubsidiesStore);

	constructor(private toastsService: ToastService) {}

	ngOnInit() {
		window.scrollTo(0, 0);
		this.toastsService.clearToast();

		if (this.step + 1 >= this.steps.length) {
			this.isLastStep.set(true);
		}

		this.subsidiesStore.subsidyPeriods$.pipe(take(1)).subscribe(periods => {
			const period = periods.find(p => p.type === this.subsidyType) || null;
			this.period.set(period);
		});
	}

	doAction(action: StepContainerAction) {
		this.action.emit(action);
	}
}
